import React from "react"
export class AppReloader extends React.Component<{ childApp, reloadTab(): Promise<any>, changeRoute(newTemplateId): Promise<any> }, { props: any, key: string }>{

    componentDidMount() {
        this.getData()
    }

    getData = async () => {
        const data: any = await this.props.reloadTab();
        this.updateState(data);
    }

    changeRoute = async (newTemplateId) => {
        const data: any = await this.props.changeRoute(newTemplateId);
        this.updateState(data);
    }

    updateState = (newState) => {
        newState.key = kendo.guid();
        newState.reloadTab = this.getData;
        newState.changeRoute = this.changeRoute;
        this.setState({ props: newState });
    }

    render() {
        const childApp = this.state && this.state.props.key ? React.createElement(this.props.childApp, this.state.props) : null;
        return childApp;
    }
}